// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K7PU9","controls":"styles_controls__1Nal9","charLimit":"styles_charLimit__3T2zC","input":"styles_input__3bSpQ","send":"styles_send__1BZQv"};